import { PooledBenchmarkPhase2Service } from "../service/asyncBatchPooledBenchmarkPhase2Service";
import * as validations from "../utils/validations";

export class PooledBenchMarkPhase2 {
  fnBurgissCalcPooledBenchmarkDPI(
    investId?: any[][],
    endDate?: any,
    idType?: string,
    selectionSetId?: any,
    weightingMethod?: any,
    filter?: any,
    currency?: string,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    let ValidateEndDate: Date | null = new Date("0001-01-01T00:00:00Z");
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    const endDateValidation = validations.isValidDate(endDate);
    if (endDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDateValidation, "E");
    if (endDate == null || endDate == "") {
      ValidateEndDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? defaultMeasuremntDateValues.endDates
          : "";
    } else if (eDate == true) {
      ValidateEndDate = endDateValidation;
    }

    if (validations.CheckDate(ValidateEndDate) == false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    requireReportedValuation = validations.validateReportedValuation(requireReportedValuation);
    if (requireReportedValuation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }
    if (requireReportedValuation == 1 || requireReportedValuation == 3) {
      return "#INVALIDPARAMETERS - 'RequireReportValuation parameter does not support'";
    }

    idType = validations.getIdType(idType, "PooledBenchmarkCalc");
    if (String(idType) == "404" || String(idType) == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    weightingMethod = validations.getWeightMethod(weightingMethod);
    if (weightingMethod.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightingMethod.toString().replace("Error", "") + "";
    }
    return new PooledBenchmarkPhase2Service().burgissCalcPooledBenchmarkDPI(
      investId,
      ValidateEndDate,
      idType,
      selectionSetId,
      weightingMethod,
      filter,
      baseorlocalcurrency,
      requireReportedValuation,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledBenchmarkTVPI(
    investId?: any[][],
    endDate?: any,
    idType?: string,
    selectionSetId?: any,
    weightingMethod?: any,
    filter?: any,
    currency?: string,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    let ValidateEndDate: Date | null = new Date("0001-01-01T00:00:00Z");
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    const endDateValidation = validations.isValidDate(endDate);
    if (endDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDateValidation, "E");
    if (endDate == null || endDate == "") {
      ValidateEndDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? defaultMeasuremntDateValues.endDates
          : "";
    } else if (eDate == true) {
      ValidateEndDate = endDateValidation;
    }

    if (validations.CheckDate(ValidateEndDate) == false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    requireReportedValuation = validations.validateReportedValuation(requireReportedValuation);
    if (requireReportedValuation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }
    if (requireReportedValuation == 1 || requireReportedValuation == 3) {
      return "#INVALIDPARAMETERS - 'RequireReportValuation parameter does not support'";
    }

    idType = validations.getIdType(idType, "PooledBenchmarkCalc");
    if (String(idType) == "404" || String(idType) == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    weightingMethod = validations.getWeightMethod(weightingMethod);
    if (weightingMethod.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightingMethod.toString().replace("Error", "") + "";
    }
    return new PooledBenchmarkPhase2Service().burgissCalcPooledBenchmarkTVPI(
      investId,
      ValidateEndDate,
      idType,
      selectionSetId,
      weightingMethod,
      filter,
      baseorlocalcurrency,
      requireReportedValuation,
      alternateCurrrency,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledBenchmarkRVPI(
    investId?: any[][],
    endDate?: any,
    idType?: string,
    selectionSetId?: any,
    weightingMethod?: any,
    filter?: any,
    currency?: string,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    investId = validations.getSingleOrRangeValues(investId);
    if (String(investId) == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for ID parameter";
    }
    selectionSetId = validations.isValidSelectionId(selectionSetId);
    if (selectionSetId == "-1") {
      return "#INVALIDPARAMETERS - Invalid format for Selection Set ID parameter";
    }
    filter = validations.isValidFilter(filter);
    if (filter == "Error") {
      return "#INVALIDPARAMETERS -Invalid Filter";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    let ValidateEndDate: Date | null = new Date("0001-01-01T00:00:00Z");
    const defaultMeasuremntDateValues = validations.measurmentDateSearch();
    const endDateValidation = validations.isValidDate(endDate);
    if (endDateValidation === false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    const eDate: boolean = validations.searchedDateInMeasurementDate(endDateValidation, "E");
    if (endDate == null || endDate == "") {
      ValidateEndDate =
        defaultMeasuremntDateValues != null && defaultMeasuremntDateValues.endDates[0] != null
          ? defaultMeasuremntDateValues.endDates
          : "";
    } else if (eDate == true) {
      ValidateEndDate = endDateValidation;
    }
    if (validations.CheckDate(ValidateEndDate) == false) {
      return "#INVALIDPARAMETERS - Invalid End Date parameter";
    }
    requireReportedValuation = validations.validateReportedValuation(requireReportedValuation);
    if (requireReportedValuation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }
    if (requireReportedValuation == 1 || requireReportedValuation == 3) {
      return "#INVALIDPARAMETERS - 'RequireReportValuation parameter does not support'";
    }

    idType = validations.getIdType(idType, "PooledBenchmarkCalc");
    if (String(idType) == "404" || String(idType) == "Invalid") {
      return "#INVALIDPARAMETERS - Invalid ID Type parameter";
    }
    weightingMethod = validations.getWeightMethod(weightingMethod);
    if (weightingMethod.toString().includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightingMethod.toString().replace("Error", "") + "";
    }
    return new PooledBenchmarkPhase2Service().burgissCalcPooledBenchmarkRVPI(
      investId,
      ValidateEndDate,
      idType,
      selectionSetId,
      weightingMethod,
      filter,
      baseorlocalcurrency,
      requireReportedValuation,
      alternateCurrrency,
      uniqueCellId
    );
  }
}
